<template>
  <div class="list-item-component">
    <router-link :to="goList ? { name: 'ReadingDayGroup' } : `https://m.youthmba.com/entity/${item.id}`"
                 class="list-item-component"
                 v-ym-report:[reportKey]="goList ? '' : { id: item.id }"
    >
      <ym-img class="list-item-component-cover"
              :src="item.cover"
      />
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'GroupItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
      goList: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      reportKey() {
        return this.goList ? 'MARKETING_2021READINGDAY_GROUPON_BUY_CLICK' : 'MARKETING_2021READINGDAY_GROUPON_MORE_BUY_CLICK';
      },
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .list-item-component {
    display: flex;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    &-cover {
      width: 720px;
      height: 220px;
      margin-left: 15px;
    }
  }
</style>
